import { ApplicantType } from '@/lib/apollo/query/get-applicant'

type ApplicantLabel = 'Tenant' | 'Guarantor'

export const toSubjectTypeLabel = (type: ApplicantType): ApplicantLabel => {
  switch (type) {
    case ApplicantType.tenant:
      return 'Tenant'
    case ApplicantType.guarantor:
      return 'Guarantor'
  }
}
